<template>
<div class="lesson-item">
	<div class="lesson-resources">
		<!-- 课堂所有者 -->
		<div class="action-btns">
			<el-card class="box-card">
				<el-button type="text" icon="el-icon-edit-outline" @click="addResources">添加资源</el-button>
			</el-card>
		</div>
		<div class="lesson-resources-tabs">
			<el-tabs tab-position="left" v-model="activeName">
				<el-tab-pane v-for="tab in tabList" :key="tab.name" :name="tab.name" :label="tab.label">
					<component :is="tab.component"/>
				</el-tab-pane>
			</el-tabs>
		</div>
		<el-dialog class="add-resources-dialog" :title="dialogTitle" :visible.sync="dialogVisible">
			<div class="add-resources" v-if="activeName == 1">
				<el-tabs v-model="activeType">
					<el-tab-pane label="从备课区资源导入" name="first"></el-tab-pane>
					<el-tab-pane label="从课程资料导入" name="second"></el-tab-pane>
				</el-tabs>
				<el-row>
					<el-col class="tabs-left" :span="4">
						<el-tabs v-model="activeSubType" tab-position="left">
							<el-tab-pane label="我的备课区域" name="first"></el-tab-pane>
							<el-tab-pane label="课堂1" name="second"></el-tab-pane>
							<el-tab-pane label="课堂2" name="three"></el-tab-pane>
						</el-tabs>
					</el-col>
					<el-col class="resources" :span="20">
						<el-checkbox class="resources-checkAll" :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">全选</el-checkbox>
						<el-checkbox-group v-model="checkedResources" @change="handleCheckedResourcesChange">
							<el-checkbox class="resources-box" v-for="city in resources" :key="city.uid" :label="city">
								<div class="resources-item">
									<div class="resources-img">
										<img :src="city.img">
									</div>
									<h3>{{city.name}}</h3>
								</div>
							</el-checkbox>
						</el-checkbox-group>
						<div class="pagination">
							<el-pagination hide-on-single-page
										layout="total, sizes, prev, pager, next, jumper"
										:current-page="currentPage"
										:page-size="pageSize"
										:pager-count="pagerCount"
										:total="totalEnclosure"
										@size-change="sizeChange"
										@current-change="currentChange">
							</el-pagination>
						</div>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="12">
						<el-button type="primary">本地上传</el-button>
					</el-col>
					<el-col class="text-r" :span="12">
						<el-button @click="dialogVisible = false">取消</el-button>
						<el-button type="primary">确定</el-button>
					</el-col>
				</el-row>
			</div>
			<div v-else-if="activeName == 2">
				<el-form ref="form" :model="form" label-width="100px">
					<el-form-item label="外链标题简介">
						<el-input v-model="form.title"></el-input>
					</el-form-item>
					<el-form-item label="外链网址链接">
						<el-input v-model="form.url"></el-input>
					</el-form-item>
					<div class="text-c">
						<el-button style="width: 33.333333%;" type="primary">导入</el-button>
					</div>
				</el-form>
			</div>
			<div class="add-lesson-res" v-else>
				<div>
					<el-input placeholder="搜索课程试试" v-model="search" class="input-with-select">
						<el-button slot="append" icon="el-icon-search"></el-button>
					</el-input>
				</div>
				<ul class="lesson-list">
					<li class="lesson-item" v-for="lesson in 12" :key="lesson">
						ff
					</li>
				</ul>
			</div>
		</el-dialog>
	</div>
</div>
</template>

<script>
import lessonResourcesEnclosures from '@/views/lesson/resources/enclosures'
import lessonResourcesLinks from '@/views/lesson/resources/links'
import lessonResourcesCurricula from '@/views/lesson/resources/curricula'
const resourcesOptions = [
	{ name: 'vsdfds', uid: '1', img: require('@/assets/imgs/star.png') },
	{ name: 'ccds', uid: '2', img: require('@/assets/imgs/star.png') },
	{ name: 'ccds', uid: '3', img: require('@/assets/imgs/star.png') },
	{ name: 'ccds', uid: '4', img: require('@/assets/imgs/star.png') },
	{ name: 'ccds', uid: '5', img: require('@/assets/imgs/star.png') },
	{ name: 'ccds', uid: '6', img: require('@/assets/imgs/star.png') },
	{ name: 'ccds', uid: '7', img: require('@/assets/imgs/star.png') },
	{ name: 'ccds', uid: '8', img: require('@/assets/imgs/star.png') },
	{ name: 'ccds', uid: '9', img: require('@/assets/imgs/star.png') }
]
export default {
	data () {
		return {
			activeName: '3',
			tabList: [
				{ name: '1', label: '附件资源', component: 'lessonResourcesEnclosures' },
				{ name: '2', label: '外链资源', component: 'lessonResourcesLinks' },
				{ name: '3', label: '课程资源', component: 'lessonResourcesCurricula' }
			],
			dialogTitle: '',
			dialogVisible: false,
			activeType: 'first',
			activeSubType: 'first',
			checkAll: false,
			isIndeterminate: false,
			checkedResources: [],
			resources: resourcesOptions,
            currentPage: 1, // 当前页数，支持 .sync 修饰符
            pageSize: 10, // 每页显示条目个数，支持 .sync 修饰符
            pagerCount: 7, // 页码按钮的数量，当总页数超过该值时会折叠(大于等于 5 且小于等于 21 的奇数)
			totalEnclosure: 21, // 总条目数
			form: {},
			search: ''
		}
	},
	components: {
		lessonResourcesEnclosures,
		lessonResourcesLinks,
		lessonResourcesCurricula
	},
	methods: {
        // pageSize 改变时会触发
        sizeChange (pageSize) {
            this.pageSize = pageSize
        },
        // currentPage 改变时会触发
        currentChange (currentPage) {
            this.currentPage = currentPage
        },
		handleCheckAllChange(value) {
			this.checkedResources = value ? this.resources : []
			this.isIndeterminate = false
		},
		handleCheckedResourcesChange(value) {
			let checkedCount = value.length
			this.checkAll = checkedCount === this.resources.length
			this.isIndeterminate = checkedCount > 0 && checkedCount < this.resources.length
		},
		addResources () {
			let title = ''
			switch (this.activeName) {
				case '1':
					title = '导入资源'
					break;
				case '2':
					title = '添加外链链接'
					break;
				case '3':
					title = '导入课程资源'
					break;
				default:
					break;
			}
			this.dialogTitle = title
			this.dialogVisible = true
		}
	}
}
</script>

<style lang="less">
.add-resources {
	.tabs-left	{
		.el-tabs {
			&--left {
				.el-tabs {
					&__header {
						&.is-left {
							float: none;
						}
					}
				}
			}
		}
	}
}
.less-resources {
	.resources {
		&-box {
			.el-checkbox {
				&__label {
					margin-left: -24px;
					vertical-align: top;
				}
			}
		}
	}
}
</style>

<style lang="less" scoped>
.add-resources-dialog {
	.lesson {
		&-list {
			margin: 20px -5px 0;
		}
		&-item {
			margin: 5px;
			display: inline-block;
			vertical-align: bottom;
		}
	}
}
.lesson-resources {
	padding-bottom: 20px;
	.action-btns {
		text-align: center;
	}
	.resources {
		&-checkAll {
			margin: 15px 0 0 15px;
		}
		&-box {
			margin: 15px;
		}
		&-item {
			width: 140px;
			text-align: center;
		}
		&-img {
			width: 100px;
			height: 100px;
			line-height: 100px;
			text-align: center;
			margin: 0 auto;
			img {
				max-width: 100%;
				max-height: 100%;
			}
		}
		.pagination {
			text-align: center;
			margin-bottom: 15px;
		}
	}
}
</style>
